import { create } from "zustand"

// messika-pwa#34 : état d'affichage des mises à jour PWA (non persisté).
interface PwaUpdateState {
   updating: boolean            // overlay bloquant « Mise à jour… »
   updateAvailable: boolean     // nouvelle version détectée (bandeau en cours de session)
   dbIncompatible: boolean      // base Dexie locale plus récente que le build (VersionError)
}

const usePwaUpdateStore = create<PwaUpdateState>()(() => ({
   updating: false,
   updateAvailable: false,
   dbIncompatible: false,
}))

export default usePwaUpdateStore
